import { render, staticRenderFns } from "./hyhd.vue?vue&type=template&id=dc3960b0&"
import script from "./hyhd.vue?vue&type=script&lang=js&"
export * from "./hyhd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports